var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "screening-formList" } },
    _vm._l(_vm.projectsData, function (field, index) {
      return _c(
        "el-card",
        {
          staticClass: "box-card left-card",
          staticStyle: { "margin-bottom": "15px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "span",
                { staticStyle: { "font-size": "16px", float: "left" } },
                [
                  _vm._v(
                    _vm._s(field.projectName) +
                      "\n              (\n                "
                  ),
                  _c(
                    "span",
                    {
                      style: {
                        "font-size": "18px",
                        "font-weight": "bold",
                        color:
                          field.checkStatus === 1
                            ? "#FF5252"
                            : field.checkStatus === 2
                            ? "#4CAF50"
                            : "#FF9800A3",
                      },
                    },
                    [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            field.checkStatus === 1
                              ? "未检查"
                              : field.checkStatus === 2
                              ? "已检查"
                              : "部分已检"
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v("\n              )\n          "),
                ]
              ),
              _c(
                "div",
                { style: { display: "flex", "justify-content": "right" } },
                [
                  _c(
                    "Button",
                    {
                      staticStyle: { "font-size": "16px" },
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit(field.projectId)
                        },
                      },
                    },
                    [_vm._v("保存项目")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "Form",
            {
              attrs: {
                model: _vm.model[field.projectName],
                showMessage: false,
              },
            },
            [
              _vm._l(
                _vm.getRowElements(
                  field.projectName,
                  field.fieldConfig,
                  field.checkStatus
                ),
                function (rowItem, rowIndex) {
                  return [
                    rowItem.isStartIndex
                      ? _c(
                          "Row",
                          _vm._l(
                            _vm.getColElements(field.projectName, rowIndex),
                            function (item, colIndex) {
                              return item.isShow
                                ? _c(
                                    "Col",
                                    {
                                      attrs: {
                                        span: item.columnNumber
                                          ? item.columnNumber
                                          : 6,
                                      },
                                    },
                                    [
                                      _c(
                                        "FormItem",
                                        {
                                          style: item.width,
                                          attrs: {
                                            prop: item.prop,
                                            label: item.label,
                                            "label-width": item.labelWidth,
                                            required:
                                              item.isRequired &&
                                              item.isRequired == 2,
                                          },
                                        },
                                        [
                                          !item.element
                                            ? _c(
                                                "Input",
                                                {
                                                  staticStyle: {
                                                    height: "35px",
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: item.type,
                                                    placeholder:
                                                      item.placeholder,
                                                    autocomplete:
                                                      item.type === "password"
                                                        ? "new-password"
                                                        : "",
                                                    size: item.size,
                                                    disabled: item.disabled,
                                                    readonly: item.readonly,
                                                    icon: item.icon,
                                                    prefix: item.prefix,
                                                    suffix: item.suffix,
                                                    clearable: true,
                                                    number: item.number,
                                                    rows: item.rows,
                                                    autosize: item.autosize,
                                                  },
                                                  on: {
                                                    "on-change": (e) =>
                                                      _vm.changePropVal(
                                                        field.projectName,
                                                        item.prop,
                                                        item.fieldCode,
                                                        e.target.value
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model[
                                                        field.projectName
                                                      ][item.prop],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model[
                                                          field.projectName
                                                        ],
                                                        item.prop,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model[field.projectName][item.prop]",
                                                  },
                                                },
                                                [
                                                  item.unit
                                                    ? _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "append",
                                                          },
                                                          slot: "append",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.unit)
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                          item.element === "number"
                                            ? _c(
                                                "Input",
                                                {
                                                  staticStyle: {
                                                    height: "35px",
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder:
                                                      item.placeholder,
                                                    size: item.size,
                                                    disabled: item.disabled,
                                                    readonly: item.readonly,
                                                    icon: item.icon,
                                                    prefix: item.prefix,
                                                    suffix: item.suffix,
                                                    clearable: true,
                                                    number: item.number,
                                                    rows: item.rows,
                                                    autosize: item.autosize,
                                                  },
                                                  on: {
                                                    "on-keyup": (e) =>
                                                      _vm.toInt(
                                                        field.projectName,
                                                        item.prop,
                                                        item.startRange,
                                                        item.endRange,
                                                        e.target.value
                                                      ),
                                                    "on-change": (e) =>
                                                      _vm.changePropVal(
                                                        field.projectName,
                                                        item.prop,
                                                        item.fieldCode,
                                                        e.target.value
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model[
                                                        field.projectName
                                                      ][item.prop],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model[
                                                          field.projectName
                                                        ],
                                                        item.prop,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model[field.projectName][item.prop]",
                                                  },
                                                },
                                                [
                                                  item.unit
                                                    ? _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "append",
                                                          },
                                                          slot: "append",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.unit)
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                          item.element === "digit"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ivu-form-item-content",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ivu-input-wrapper ivu-input-wrapper-default ivu-input-type-text ivu-input-group ivu-input-group-default ivu-input-group-with-append ivu-input-hide-icon",
                                                    },
                                                    [
                                                      _c("Input", {
                                                        staticStyle: {
                                                          height: "35px",
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          type: item.type,
                                                          placeholder:
                                                            item.placeholder,
                                                          size: item.size,
                                                          disabled:
                                                            item.disabled,
                                                          readonly:
                                                            item.readonly,
                                                          icon: item.icon,
                                                          prefix: item.prefix,
                                                          suffix: item.suffix,
                                                          clearable: true,
                                                          number: item.number,
                                                          rows: item.rows,
                                                          autosize:
                                                            item.autosize,
                                                        },
                                                        on: {
                                                          "on-keyup": (e) =>
                                                            _vm.toDigit(
                                                              field.projectName,
                                                              item.prop,
                                                              item.startRange,
                                                              item.endRange,
                                                              e.target.value
                                                            ),
                                                          "on-change": (e) =>
                                                            _vm.changePropVal(
                                                              field.projectName,
                                                              item.prop,
                                                              item.fieldCode,
                                                              e.target.value
                                                            ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model[
                                                              field.projectName
                                                            ][item.prop],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model[
                                                                field
                                                                  .projectName
                                                              ],
                                                              item.prop,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model[field.projectName][item.prop]",
                                                        },
                                                      }),
                                                      item.historyValue
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "ivu-input-group-append",
                                                              staticStyle: {
                                                                "background-color":
                                                                  "rgb(221 63 63 / 12%)",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.historyValue
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      item.unit
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "ivu-input-group-append",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.unit
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          item.element === "textarea"
                                            ? _c("Input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "textarea",
                                                  placeholder: item.placeholder,
                                                  clearable: true,
                                                  size: item.size,
                                                  disabled: item.disabled,
                                                  readonly: item.readonly,
                                                  icon: item.icon,
                                                  prefix: item.prefix,
                                                  suffix: item.suffix,
                                                  number: item.number,
                                                  rows: item.rows,
                                                  autosize: item.autosize,
                                                },
                                                on: {
                                                  "on-change": (e) =>
                                                    _vm.changePropVal(
                                                      field.projectName,
                                                      item.prop,
                                                      item.fieldCode,
                                                      e.target.value
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.model[
                                                      field.projectName
                                                    ][item.prop],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.model[
                                                        field.projectName
                                                      ],
                                                      item.prop,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model[field.projectName][item.prop]",
                                                },
                                              })
                                            : _vm._e(),
                                          item.element === "select"
                                            ? _c(
                                                "Select",
                                                {
                                                  staticStyle: {
                                                    height: "35px",
                                                    width: "100%",
                                                  },
                                                  style: item.elemWidth,
                                                  attrs: {
                                                    placeholder:
                                                      item.placeholder,
                                                    clearable: true,
                                                    size: item.size,
                                                    disabled: item.disabled,
                                                    filterable: item.filterable,
                                                    multiple: item.multiple,
                                                    transfer: "",
                                                  },
                                                  on: {
                                                    "on-change": (value) =>
                                                      _vm.changePropVal(
                                                        field.projectName,
                                                        item.prop,
                                                        item.fieldCode,
                                                        value
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model[
                                                        field.projectName
                                                      ][item.prop],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model[
                                                          field.projectName
                                                        ],
                                                        item.prop,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model[field.projectName][item.prop]",
                                                  },
                                                },
                                                _vm._l(
                                                  item.option,
                                                  function (opt, index) {
                                                    return _c(
                                                      "Option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: opt.value,
                                                          disabled:
                                                            opt.disabled,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(opt.label)
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e(),
                                          item.element === "cascader"
                                            ? _c("MyCascader", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  size: item.size,
                                                  placeholder: item.placeholder,
                                                  options: item.option,
                                                  collapseTags: false,
                                                  code: item.code,
                                                  name: item.name,
                                                  filterable: false,
                                                  clearable: "",
                                                  disabled: item.disabled,
                                                },
                                                on: {
                                                  "on-change": (value) =>
                                                    _vm.changePropVal(
                                                      field.projectName,
                                                      item.prop,
                                                      item.fieldCode,
                                                      value
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.model[
                                                      field.projectName
                                                    ][item.prop],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.model[
                                                        field.projectName
                                                      ],
                                                      item.prop,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model[field.projectName][item.prop]",
                                                },
                                              })
                                            : _vm._e(),
                                          item.element === "date"
                                            ? _c("DatePicker", {
                                                staticStyle: {
                                                  height: "35px",
                                                  width: "100%",
                                                },
                                                style: item.elemWidth,
                                                attrs: {
                                                  editable: false,
                                                  type: item.type,
                                                  options: item.options,
                                                  format: item.format,
                                                  placeholder: item.placeholder,
                                                  size: item.size,
                                                  disabled: item.disabled,
                                                  transfer: "",
                                                },
                                                on: {
                                                  "on-change": (value) =>
                                                    _vm.changePropVal(
                                                      field.projectName,
                                                      item.prop,
                                                      item.fieldCode,
                                                      value
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.model[
                                                      field.projectName
                                                    ][item.prop],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.model[
                                                        field.projectName
                                                      ],
                                                      item.prop,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model[field.projectName][item.prop]",
                                                },
                                              })
                                            : _vm._e(),
                                          item.element === "time"
                                            ? _c("TimePicker", {
                                                staticStyle: {
                                                  height: "35px",
                                                  width: "100%",
                                                },
                                                style: item.elemWidth,
                                                attrs: {
                                                  type: item.type,
                                                  format: item.format,
                                                  placeholder: item.placeholder,
                                                  size: item.size,
                                                  disabled: item.disabled,
                                                  transfer: "",
                                                },
                                                on: {
                                                  "on-change": (value) =>
                                                    _vm.changePropVal(
                                                      field.projectName,
                                                      item.prop,
                                                      item.fieldCode,
                                                      value
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    _vm.model[
                                                      field.projectName
                                                    ][item.prop],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.model[
                                                        field.projectName
                                                      ],
                                                      item.prop,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model[field.projectName][item.prop]",
                                                },
                                              })
                                            : _vm._e(),
                                          item.element === "radio"
                                            ? _c(
                                                "RadioGroup",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: item.type,
                                                    size: item.size,
                                                    vertical: item.vertical,
                                                  },
                                                  on: {
                                                    "on-change": (value) =>
                                                      _vm.changePropVal(
                                                        field.projectName,
                                                        item.prop,
                                                        item.fieldCode,
                                                        value
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model[
                                                        field.projectName
                                                      ][item.prop],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model[
                                                          field.projectName
                                                        ],
                                                        item.prop,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model[field.projectName][item.prop]",
                                                  },
                                                },
                                                _vm._l(
                                                  item.option,
                                                  function (opt, index) {
                                                    return _c(
                                                      "Radio",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          label: opt.value,
                                                          size: item.size,
                                                          disabled:
                                                            opt.disabled,
                                                        },
                                                        nativeOn: {
                                                          dblclick: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return (() => {
                                                              _vm.model[
                                                                field.projectName
                                                              ][item.prop] =
                                                                null
                                                            }).apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(opt.label)
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e(),
                                          item.element === "checkbox"
                                            ? _c("MyCheckBox", {
                                                key: item.prop + index,
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "ignore-list":
                                                    item.ignoreList,
                                                  enumList: item.option,
                                                  dataStr:
                                                    _vm.model[
                                                      field.projectName
                                                    ][item.prop],
                                                  disabled: item.disabled,
                                                },
                                                on: {
                                                  "update:dataStr": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.model[
                                                        field.projectName
                                                      ],
                                                      item.prop,
                                                      $event
                                                    )
                                                  },
                                                  "update:data-str": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.model[
                                                        field.projectName
                                                      ],
                                                      item.prop,
                                                      $event
                                                    )
                                                  },
                                                  "on-change": (value) =>
                                                    _vm.changePropVal(
                                                      field.projectName,
                                                      item.prop,
                                                      item.fieldCode,
                                                      value
                                                    ),
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }
                          ),
                          1
                        )
                      : _vm._e(),
                  ]
                }
              ),
            ],
            2
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }